import Vue from 'vue';
import cookie from '../../cookie/cookie';
import repaymentContractDraw from './single-import-contract-draw.vue';
import repaymentPlanAdd from './single-import-add.vue';
export default Vue.extend({
    name: 'login',
    components: {
        'el-repayment-contract-draw': repaymentContractDraw,
        'el-repayment-add': repaymentPlanAdd,
    },
    computed: {},
    data: function () {
        return {
            active: 0,
            contractCode: '',
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        contractDrawCallback: function (_a) {
            var num = _a.num, contractCode = _a.contractCode;
            this.contractCode = contractCode;
            this.activeChange(num);
        },
        activeChange: function (num) {
            num > 0 ? (this.active = 1) : (this.active = 0);
        },
        stepMain: function (flag) {
            flag === 0 && (this.active = 0);
        },
    },
});
